import DatePickerSingle from './single';
import DatePickerSingleChk from './singleChk';
import DatePickerRange from './range';

class DatePicker{}

DatePicker.Single = DatePickerSingle;
DatePicker.Range = DatePickerRange;
DatePicker.ChkSingle = DatePickerSingleChk;

export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/datepicker/index.js